<template>
    <a-form-model :model="form" :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" class="bank-info-form">
        <a-form-model-item label="开户行">
            <a-input v-model="form.bank" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="账号">
            <a-input v-model="form.accountNo" size="large" placeholder="请输入"> </a-input>
        </a-form-model-item>
    </a-form-model>
</template>

<script>
export default {
    data() {
        return {
            form: {
                bank: '',
                accountNo: ''
            }
        };
    },
    methods: {}
};
</script>

<style lang="scss" scoped></style>
